
  <mat-card class="filter">  
    <label>Notifications</label>
    <div class="add">
      <mat-form-field appearance="fill">
        <mat-label>Search notifications here...</mat-label>
        <input matInput type="text"  maxlength="30"
          (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)">
      </mat-form-field>
    </div>
  </mat-card>

<mat-card class="allnoti">
    <div class="headings">
        <h4>Total -  {{UnreadNotification}}/ {{TotalNotification}}</h4>
        <a  *ngIf="UnreadNotification > 0"  (click)="Markallasread()">Mark all as read </a>
    </div>
  <div class="notifications">
      <ul *ngFor="let noti of NotificationList">
        <li class="notirep" (click)="MarkPerticularRead(noti)" *ngIf="noti.isRead">
            <div class="userpic" *ngIf="noti.imageUrl">
                <img [src]="noti.imageUrl" alt="" />
            </div>
            <div class="userpic" *ngIf="!noti.imageUrl">
                <span class="shortName">{{getShortName(noti.senderName)}}</span>                
            </div>
            <div class="text"> 
                <p><b>{{noti.senderName |titlecase}}</b> {{noti.message}}</p>                
            </div>
           
            <span>{{noti.createdOn| DayAgo}} </span>
        </li>
        <li class="notirep unread" (click)="MarkPerticularRead(noti)" *ngIf="!noti.isRead">
            <div class="userpic" *ngIf="noti.imageUrl">
                <img [src]="noti.imageUrl" alt="" />
            </div>
            <div class="userpic" *ngIf="!noti.imageUrl">
                <span class="shortName">{{getShortName(noti.senderName)}}</span>                
            </div>
            <div class="text"> 
                <p><b>{{noti.senderName|titlecase}}</b> {{noti.message}}</p>                
            </div>
           
            <span>{{noti.createdOn| DayAgo}} </span>
        </li>    
      </ul>
  </div>
  
</mat-card>

<mat-paginator [length]="paginatorTotalLength"
  [pageIndex]="pageIndex" [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 20, 30]"
  itemsPerPageLabel="Records Per Page" showFirstLastButtons
  (page)="pageEventPropogate($event)">
  </mat-paginator>